module.exports = __webpack_public_path__ + "static/media/dropdown.5f22eef4.svg";